var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79627 1.51359C7.34018 1.02117 6.70315 0.75 6.00002 0.75C5.29315 0.75 4.65401 1.01953 4.20002 1.50891C3.74112 2.00367 3.51752 2.67609 3.57002 3.40219C3.67409 4.83469 4.76416 6 6.00002 6C7.23588 6 8.32408 4.83492 8.42979 3.40265C8.48299 2.68312 8.25799 2.01211 7.79627 1.51359Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1249 11.249H1.87489C1.7669 11.2504 1.65996 11.2277 1.56185 11.1826C1.46374 11.1375 1.37691 11.0711 1.3077 10.9882C1.15536 10.8061 1.09395 10.5574 1.13942 10.3059C1.33723 9.20855 1.95458 8.28676 2.92489 7.63965C3.78692 7.0652 4.87887 6.74902 5.99989 6.74902C7.1209 6.74902 8.21285 7.06543 9.07488 7.63965C10.0452 8.28652 10.6625 9.20832 10.8604 10.3057C10.9058 10.5571 10.8444 10.8058 10.6921 10.9879C10.6229 11.0709 10.5361 11.1373 10.438 11.1825C10.3398 11.2277 10.2329 11.2504 10.1249 11.249Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b183819479053e994ca557b470702a7e.svg";
export { ForwardRef as ReactComponent };